import { z } from 'zod';

/**
 * @description Sport::Session _type properties
 * @see ConstantsService::SPORT_SESSION__TYPES
 */

export enum SPORT_SESSION_TYPES {
  SPORT_SESSION = 'Sport::Session',
  SPORT_SESSION_BIKE = 'Sport::Session::Bike',
  SPORT_SESSION_FITNESS = 'Sport::Session::Fitness',
  SPORT_SESSION_HIKE = 'Sport::Session::Hike',
  SPORT_SESSION_OTHER = 'Sport::Session::Other',
  SPORT_SESSION_RUN = 'Sport::Session::Run',
  SPORT_SESSION_SWIM = 'Sport::Session::Swim',
  SPORT_SESSION_TRANSITION = 'Sport::Session::Transition',
  SPORT_SESSION_WALKING = 'Sport::Session::Walking',
  SPORT_SESSION_STRENGTH = 'Sport::Session::Strength',
  SPORT_SESSION_YOGA = 'Sport::Session::Yoga',
}

export const SportSessionTypesSchema = z.nativeEnum(SPORT_SESSION_TYPES);
